import React, { useRef, useEffect, useState, useMemo } from "react";
import Slider from "react-slick";
import styles from './mobileSlider.module.scss';

function MobileSlider({ resources, sliderRef }) {
    const pages = useMemo(() => {
        return resources.reduce((acc, resource, index) => {
            const pageIndex = Math.floor(index / 1);
            if (!acc[pageIndex]) {
                acc[pageIndex] = [];
            }
            acc[pageIndex].push(resource);
            return acc;
        }, []);
    }, [resources]);

    const settings = {
        dots: false,
        arrows: false,
        speed: 500,
    };

    return (
        <Slider className={styles.mobileSlider} {...settings} ref={sliderRef}>
            {pages.map((page, index) => (
                <div key={index} className={styles.mobileSliderPage}>
                    {page.map((resource) => (
                        <div key={index} className={styles.mobileSliderItem}>
                            <img
                                className={styles.image}
                                src={resource.image}
                                alt={resource.title}
                            />
                            <div className={styles.content}>
                                <h4>{resource.title}</h4>
                                <p>{resource.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </Slider>
    );
}

export default MobileSlider;